import { MINIMUM_NUMBER_OF_CHARACTERS_TO_START_SEARCH } from '../constants/minimum-number-of-characters-to-start-search';
import { PageKeys } from '../../../../state/reducers/filterSortReducer';

export const getPlaceholderForMinSearchChars = (pageKey: PageKeys, filterFieldName, translate) => `${
    translate(`${ pageKey }-${ filterFieldName }-filter`) } (${
    translate(`min-X-characters`, { X: MINIMUM_NUMBER_OF_CHARACTERS_TO_START_SEARCH })
  })`;
